import QRCode from "qrcode";

export async function downloadQr(url: string, filename: string, batchCode?: string) {
  const qrCanvas = document.createElement("canvas");

  await QRCode.toCanvas(qrCanvas, url, {
    width: 300,
    margin: 2,
    errorCorrectionLevel: 'H',
  });

  // Create a single canvas to hold QR code + batch code text
  const finalCanvas = document.createElement("canvas");
  const ctx = finalCanvas.getContext("2d");
  
  if (!ctx) return;

  const qrSize = 300;
  const padding = 20;
  const textHeight = batchCode ? 25 : 0;
  
  finalCanvas.width = qrSize + padding * 2;
  finalCanvas.height = qrSize + padding * 2 + textHeight;

  // Fill background with white
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

  // Draw QR code centered
  ctx.drawImage(qrCanvas, padding, padding);

  // Draw batch code text below QR code if provided (with minimal gap)
  if (batchCode) {
    ctx.fillStyle = "black";
    ctx.font = "bold 26px Arial";
    ctx.textAlign = "center";
    const textY = qrSize + padding * 1.5 + 12;
    ctx.fillText(batchCode, finalCanvas.width / 2, textY);
  }

  const link = document.createElement("a");
  link.href = finalCanvas.toDataURL("image/png");
  link.download = filename;
  link.click();
}
// 